import t from "./index252.js";
import { resolveComponent as n, createBlock as r, createCommentVNode as p, openBlock as a, withCtx as c, createTextVNode as m, toDisplayString as s } from "vue";
import i from "./index231.js";
function d(e, f, l, _, k, u) {
  const o = n("cs-copy-text-link");
  return e.computedLink ? (a(), r(o, {
    key: 0,
    href: e.computedLink,
    target: "_blank",
    rel: "nofollow noopener",
    "data-mod": e.$options.name
  }, {
    default: c(() => [
      m(s(e.text), 1)
    ]),
    _: 1
  }, 8, ["href", "data-mod"])) : p("", !0);
}
const y = /* @__PURE__ */ i(t, [["render", d]]);
export {
  y as default
};
